/**
 * Operator groups for junction-kind FieldTypes.
 *
 * Subtypes inherit from their parent via the chain walk in `../operators`.
 */

import { hasAll, hasAny } from "./array.js"
import type { OperatorGroup } from "./index.js"
import { includes } from "./membership.js"
import { isEmpty, isNotEmpty } from "./presence.js"
import { isType } from "./relationship.js"

const presence: OperatorGroup = { label: "Presence", operators: [isEmpty, isNotEmpty] }

export const operatorGroups: Record<string, OperatorGroup[]> = {
  link: [
    {
      label: "Match",
      operators: [
        { ...includes, label: "is" },
        { ...hasAny, label: "is any of" },
        { ...hasAll, label: "is all of" },
        { ...isType, label: "is type" },
      ],
    },
    presence,
  ],
  tagging: [
    {
      label: "Match",
      operators: [
        { ...hasAny, label: "has any of" },
        { ...hasAll, label: "has all of" },
      ],
    },
    presence,
  ],
  attachment: [presence],
}
